module.exports = __webpack_public_path__ + "img/seahub-logo.1d5b9e11.png";